const REDIRECT_KEY = 'google_redirect_initiated_at';

export const redirectGuard = {
  getTimestamp(): number | null {
    try {
      const v = sessionStorage.getItem(REDIRECT_KEY);
      if (!v) return null;
      const ts = Number(v);
      return Number.isNaN(ts) ? null : ts;
    } catch (e) {
      return null;
    }
  },

  setTimestamp(ts: number = Date.now()): void {
    try {
      sessionStorage.setItem(REDIRECT_KEY, String(ts));
    } catch (e) {
      // swallow
    }
  },

  clear(): void {
    try {
      sessionStorage.removeItem(REDIRECT_KEY);
    } catch (e) {
      // swallow
    }
  },

  isRecent(ttlMs: number): boolean {
    const ts = this.getTimestamp();
    if (!ts) return false;
    return Date.now() - ts < ttlMs;
  }
};

export default redirectGuard;
